import { Api } from "../ApiConfig"
import { ApiException } from "../ApiException"
import { IReportMetricsBody } from "../../../@types/reports-metrics.type";
import { IPosition } from "../../../@types/position.type";
import { IApiResponse } from "../../../@types/api-response.type";
import { downloadExcel } from "../../../utils/download";
import { getErrorMessage } from "../../../utils/utils";

export const getPositionsMetrics = async (role: IReportMetricsBody) => {
    try {
        const { data } = await Api.post("/api/Position/GetPositionsMetrics",
        {"id": role.id, "startTime": role.startTime, 
        "endTime": role.endTime, "timeType": role.timeType});
        return data;
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao consultar metricas da Função'))
    } 
}

export const getAllPositions = async () => {
    try {
        const { data } = await Api.get("/api/Position/GetAllPositions")
        return data;
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao consultar todas as Funções'))
    } 
}

export const getAllPositionsIdsAndNames = async () => {
  try {
   
      const { data } = await Api.get(`/api/Position/GetAllPositionsIdsAndNames`);
      return data.result
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar Funções'))
  }
}

export const deletePosition = async (id: string) => {

    try {
      await Api.delete(`/api/Position/DeletePosition/${id}`);
    } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao deletar a Função'))
    }
  }

export const addOrUpdatePosition = async (position: IPosition) => {
    try {
        const { data } = await Api.post(`api/Position/AddOrUpdatePosition`, position)
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao criar Função'))
    }
};

export const getPositionById = async (id: string) : Promise<IApiResponse<IPosition> | ApiException> => {
    try {
        const { data } = await Api.get<IApiResponse<IPosition>>(`/api/Position/GetPositionById?id=${id}`)
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar Função por Id'))
    } 
}


export const downloadPositionsReportToExcel = async (filters: IReportMetricsBody): Promise<void> => {
    try {
      const response = await Api.post("/api/Position/DownloadPositionsReportToExcel",
        filters  , { responseType: "blob" });
  
      downloadExcel("Relatorio-Funcao", response.data);
    } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao fazer download do relatório de Funções'))
    }
  }

export const PositionsService = {
    getPositionsMetrics,
    getAllPositions,
    getAllPositionsIdsAndNames,
    deletePosition,
    addOrUpdatePosition,
    downloadPositionsReportToExcel
}
